
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../../services/timesheetreportsService';
import {timesheetService} from '../../services/timesheetService';
import {timesheetuserService} from '../../services/timesheetUserservice';
import {formatterhelper} from '../../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {loader} from '../../compnents/loadermd';
import { Dialog } from 'primereact/dialog';
import { FaBeer,FaCheck,FaEdit,FaRecycle,FaSearch } from "react-icons/fa";
import Smallloader from '../../compnents/loader';
import {adminService} from '../../services/adminService';
import { Toast } from 'primereact/toast';

const BulkUserUpload = ({tabname}) => {
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        projectname: '',
      });

    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [isloaded,setloading] = useState(true);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [addtimesheettoggle,settoggle] = useState(false); 
    const [editobj,seteditobj] = useState(null);
    const [errors, setErrors] = useState({});
     
     
    useEffect(()=>{

    },[]);

    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log('form daat');
        // console.log(formData.projectname);
       // addproject({project:formData.projectname});
    };
    const [fileselected, setexcelFile] = useState('');
    function selectexcelfile(event){
        const file = event.target.files[0];
        const reader = new FileReader();
        let base64String = '';
        reader.onload = function(event) {
            base64String = event.target.result;
            base64String = base64String.split("base64,")[1];
            let json_data = {
                "file_data":base64String
            };
            setexcelFile(json_data);
            
        };
        reader.readAsDataURL(file);
    }
    function importexcelfile(){
        if(fileselected == ''){
            toast.current.show({ severity: 'error', summary: 'Bulk Users Upload', detail: 'Select file first', life: 3000 });   
            return;
        }
        timesheetService.uploadBulkUsers({file:fileselected}).then((response)=>{
            
            if(response.status == 200){
                setexcelFile('');
                toast.current.show({ severity: 'success', summary: 'Bulk Users Upload', detail: response.data.data, life: 3000 }); 
            }else{
                toast.current.show({ severity: 'error', summary: 'Bulk Users Upload', detail: 'Not updated', life: 3000 });   
            } 
        }).catch((error)=>{
            // console.log(error);
            toast.current.show({ severity: 'error', summary: 'Bulk Users Upload', detail: 'Not updated', life: 3000 });   
        });
    }
    const downloadusers_sample  = ()=>{
        timesheetService.downloadusers_sample().then((response) => {
        });
      }
    return (
        <>
             <Toast ref={toast} />
            <div className="invisible-divider-sm"></div>
            <h6 className='card-style-padding-two'>{tabname}</h6>
            <div className='card card-custom-style card-style-padding'>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className="col-md-4">
                        {/* <label className='pull-left'>Project Name</label> */}
                       {/* <a style={{color:'blue',cursor:'pointer'}} onClick={download_sample} download>Download Sample File</a><br></br> */}
                        <a href="javascript:void(0);" onClick={downloadusers_sample}>Download template</a>
                        {/* <button onClick={downloadusers_sample}>Download template</button> */}
                        <br/>
                        <br/>
                        Choose xlsx, xls File: 
                        <input type="file" onChange={(e) => selectexcelfile(e)} accept=".xls, .xlsx" />
                        {errors.projectname && <span className='error'>{errors.projectname}</span>}
                    </div>
                    <br></br>
                    <div className="col-md-3 col-sm-12">
                        <div className='button-wrapper-style'>
                            <Button type='submit' onClick={()=>importexcelfile()} stype="button" label="Upload" severity="success" rounded className='custom-btn-style' />
                        </div>

                    </div>
                </div>
                </form>
            </div>
            
        </>
    );
}

export default BulkUserUpload;
